import { render, staticRenderFns } from "./MetaForm.vue?vue&type=template&id=4b3807bc"
import script from "./MetaForm.vue?vue&type=script&lang=ts"
export * from "./MetaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports